<template>
  <div class="first-board-preselection" v-if="showContent" :class="{ 'is-embed': embedResults }">
    <div v-if="!embedResults" class="page-tabs">
      <button
        type="button"
        class="page-tab"
        :class="{ 'is-active': pageTab === 'first' }"
        @click="pageTab = 'first'"
      >首板预选</button>
      <button
        type="button"
        class="page-tab"
        :class="{ 'is-active': pageTab === 'switch' }"
        @click="pageTab = 'switch'"
      >切换预选</button>
    </div>
    <div v-if="!embedResults && pageTab !== 'switch'" class="search-area" :class="{ 'search-area--mobile': isMobile }">
      <template v-if="!isMobile">
        <el-row class="search-row">
          <el-col :lg="6" :sm="24" :md="9">
            <span class="search-area-label">龙头:</span>
            <el-select
              :size="isMini"
              class="search-area-select"
              v-model="selectedLeader"
              filterable
              remote
              clearable
              :popper-append-to-body="false"
              value-key="value"
              placeholder="请输入股票名称"
              :remote-method="searchStock"
              :loading="searchLoading"
              @change="handleLeaderChange"
            >
              <el-option
                v-for="item in stockSelectOptions"
                :key="item.value"
                :label="item.label"
                :value="item"
              />
            </el-select>
            <span class="leader-meta" :title="leaderFreeFloatTitle">
              <span class="leader-price">价格：{{ leaderClosePriceText }}</span>
              <span class="leader-ffmc">自由流通市值：{{ leaderFreeFloatText }}</span>
            </span>
          </el-col>
          <el-col :lg="5" :sm="24" :md="9" class="sm-mt md-mt">
            <span class="search-area-label">概念:</span>
            <el-select
              :size="isMini"
              class="search-area-select"
              v-model="conceptSource"
              @change="onConceptSourceChange"
            >
              <el-option
                v-for="item in conceptSourceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :lg="5" :sm="24" :md="9" class="sm-mt md-mt search-col-actions">
            <el-button
              :size="isMini"
              class="analyze-btn"
              type="primary"
              @click="analyze"
              :loading="analyzeLoading"
              :disabled="!selectedLeader || analyzeLoading"
            >
              开始分析
            </el-button>
            <el-button :size="isMini" class="config-btn" @click="openAnalyzeConfig">
              配置
            </el-button>
            <el-checkbox v-if="!boardLock" v-model="onlyChiNext" class="chinext-check" :size="isMini">
              仅匹配创业板
            </el-checkbox>
          </el-col>
        </el-row>
        <el-row class="search-row search-row--dates">
          <el-col :lg="6" :sm="24" :md="8">
            <span class="search-area-label">参考日:</span>
            <el-date-picker
              :size="isMini"
              v-model="refDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="MA参考日"
              class="search-area-select search-area-date"
              @change="onRefDateChange"
            />
          </el-col>
        </el-row>
        <el-row class="search-row search-row--buzhang" :gutter="8">
          <el-col :lg="6" :sm="24" :md="8">
            <span class="search-area-label">补涨1:</span>
            <el-select
              :size="isMini"
              class="search-area-select"
              v-model="selectedBuZhang1"
              filterable
              remote
              clearable
              :popper-append-to-body="false"
              value-key="value"
              placeholder="可选"
              :remote-method="searchStock"
              :loading="searchLoading"
              @change="handleBuZhangChange"
            >
              <el-option
                v-for="item in stockSelectOptions"
                :key="'bz1-' + item.value"
                :label="item.label"
                :value="item"
              />
            </el-select>
          </el-col>
          <el-col :lg="6" :sm="24" :md="8" class="sm-mt md-mt">
            <span class="search-area-label">补涨2:</span>
            <el-select
              :size="isMini"
              class="search-area-select"
              v-model="selectedBuZhang2"
              filterable
              remote
              clearable
              :popper-append-to-body="false"
              value-key="value"
              placeholder="可选"
              :remote-method="searchStock"
              :loading="searchLoading"
              @change="handleBuZhangChange"
            >
              <el-option
                v-for="item in stockSelectOptions"
                :key="'bz2-' + item.value"
                :label="item.label"
                :value="item"
              />
            </el-select>
          </el-col>
          <el-col :lg="6" :sm="24" :md="8" class="sm-mt md-mt">
            <span class="search-area-label">补涨3:</span>
            <el-select
              :size="isMini"
              class="search-area-select"
              v-model="selectedBuZhang3"
              filterable
              remote
              clearable
              :popper-append-to-body="false"
              value-key="value"
              placeholder="可选"
              :remote-method="searchStock"
              :loading="searchLoading"
              @change="handleBuZhangChange"
            >
              <el-option
                v-for="item in stockSelectOptions"
                :key="'bz3-' + item.value"
                :label="item.label"
                :value="item"
              />
            </el-select>
          </el-col>
        </el-row>
      </template>
      <template v-else>
        <div class="search-area__row search-area__row--leader">
          <span class="search-area-label">龙头:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="selectedLeader"
            filterable
            remote
            clearable
            :popper-append-to-body="false"
            value-key="value"
            placeholder="请输入股票名称"
            :remote-method="searchStock"
            :loading="searchLoading"
            @change="handleLeaderChange"
          >
            <el-option
              v-for="item in stockSelectOptions"
              :key="item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
          <el-button size="mini" class="config-btn" @click="openAnalyzeConfig">
            配置
          </el-button>
          <el-checkbox v-if="!boardLock" v-model="onlyChiNext" class="chinext-check" size="mini">
            仅匹配创业板
          </el-checkbox>
        </div>
        <div class="search-area__row search-area__row--ffmc">
          <span class="leader-meta" :title="leaderFreeFloatTitle">
            <span class="leader-price">价格：{{ leaderClosePriceText }}</span>
            <span class="leader-ffmc">自由流通市值：{{ leaderFreeFloatText }}</span>
          </span>
        </div>
        <div class="search-area__row search-area__row--buzhang">
          <span class="search-area-label">补涨1:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="selectedBuZhang1"
            filterable
            remote
            clearable
            :popper-append-to-body="false"
            value-key="value"
            placeholder="可选"
            :remote-method="searchStock"
            :loading="searchLoading"
            @change="handleBuZhangChange"
          >
            <el-option
              v-for="item in stockSelectOptions"
              :key="'m-bz1-' + item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-area__row search-area__row--buzhang">
          <span class="search-area-label">补涨2:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="selectedBuZhang2"
            filterable
            remote
            clearable
            :popper-append-to-body="false"
            value-key="value"
            placeholder="可选"
            :remote-method="searchStock"
            :loading="searchLoading"
            @change="handleBuZhangChange"
          >
            <el-option
              v-for="item in stockSelectOptions"
              :key="'m-bz2-' + item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-area__row search-area__row--buzhang">
          <span class="search-area-label">补涨3:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="selectedBuZhang3"
            filterable
            remote
            clearable
            :popper-append-to-body="false"
            value-key="value"
            placeholder="可选"
            :remote-method="searchStock"
            :loading="searchLoading"
            @change="handleBuZhangChange"
          >
            <el-option
              v-for="item in stockSelectOptions"
              :key="'m-bz3-' + item.value"
              :label="item.label"
              :value="item"
            />
          </el-select>
        </div>
        <div class="search-area__row search-area__row--dates">
          <span class="search-area-label">参考日:</span>
          <el-date-picker
            size="mini"
            v-model="refDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="MA参考日"
            class="search-area-select"
            @change="onRefDateChange"
          />
        </div>
        <div class="search-area__row search-area__row--concept">
          <span class="search-area-label">概念:</span>
          <el-select
            size="mini"
            class="search-area-select"
            v-model="conceptSource"
            :popper-append-to-body="false"
            @change="onConceptSourceChange"
          >
            <el-option
              v-for="item in conceptSourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button
            size="mini"
            class="analyze-btn"
            type="primary"
            @click="analyze"
            :loading="analyzeLoading"
            :disabled="!selectedLeader || analyzeLoading"
          >
            开始分析
          </el-button>
        </div>
      </template>
    </div>

    <div
      v-if="!embedResults && pageTab === 'switch'"
      class="search-area switch-search"
      :class="{ 'search-area--mobile': isMobile }"
    >
      <div class="search-area__row switch-search__row">
        <span class="search-area-label">回测日:</span>
        <el-date-picker
          :size="isMini"
          v-model="switchBacktestDate"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="回测日"
          class="search-area-select search-area-date"
          :clearable="false"
          @change="onSwitchDateChange"
        />
        <span class="search-area-label">主概念1:</span>
        <el-select
          :size="isMini"
          class="search-area-select"
          v-model="switchMain1"
          filterable
          remote
          clearable
          allow-create
          default-first-option
          placeholder="可空"
          :remote-method="searchConcept"
          :loading="conceptSearchLoading"
        >
          <el-option
            v-for="item in switchConceptOptions"
            :key="'sw1-' + item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="search-area__row switch-search__row">
        <span class="search-area-label">主概念2:</span>
        <el-select
          :size="isMini"
          class="search-area-select"
          v-model="switchMain2"
          filterable
          remote
          clearable
          allow-create
          default-first-option
          placeholder="可空"
          :remote-method="searchConcept"
          :loading="conceptSearchLoading"
        >
          <el-option
            v-for="item in switchConceptOptions"
            :key="'sw2-' + item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-button
          :size="isMini"
          class="analyze-btn"
          type="primary"
          :loading="analyzeLoading"
          @click="analyze"
        >开始分析</el-button>
        <el-button :size="isMini" class="config-btn" @click="openAnalyzeConfig">配置</el-button>
        <el-checkbox v-if="!boardLock" v-model="onlyChiNext" class="chinext-check" :size="isMini">
          仅匹配创业板
        </el-checkbox>
      </div>
    </div>

    <el-dialog
      title="配置"
      :visible.sync="configDialogVisible"
      width="400px"
      append-to-body
      custom-class="first-board-config-dialog"
    >
      <el-form label-width="120px" size="small">
        <el-form-item label="价格上限">
          <el-input
            :value="configDraft.maxPrice"
            class="config-dialog-input"
            @input="onConfigDigitsInput('maxPrice', $event)"
          />
          <span class="config-dialog-unit">元</span>
        </el-form-item>
        <el-form-item label="市值下限">
          <el-input
            :value="configDraft.minMarketCapYi"
            class="config-dialog-input"
            @input="onConfigDigitsInput('minMarketCapYi', $event)"
          />
          <span class="config-dialog-unit">亿</span>
        </el-form-item>
        <el-form-item label="市值上限">
          <el-input
            :value="configDraft.maxMarketCapYi"
            class="config-dialog-input"
            @input="onConfigDigitsInput('maxMarketCapYi', $event)"
          />
          <span class="config-dialog-unit">亿</span>
        </el-form-item>
        <el-form-item label="返回条数">
          <el-input
            :value="configDraft.resultLimit"
            class="config-dialog-input"
            maxlength="3"
            @input="onConfigDigitsInput('resultLimit', $event)"
          />
          <span class="config-dialog-unit">条</span>
        </el-form-item>
        <el-form-item v-if="!embedResults && pageTab === 'switch'" label="中期筹码上限">
          <el-input
            :value="configDraft.maxMidChipPct"
            class="config-dialog-input"
            placeholder="空则不限"
            @input="onConfigChipInput"
          />
          <span class="config-dialog-unit">%</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="configDialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmAnalyzeConfig">确 定</el-button>
      </span>
    </el-dialog>

    <div
      v-if="embedResults || pageTab !== 'switch'"
      class="concepts-area"
      :class="{ 'concepts-area--empty': !embedResults && !allConceptsList.length }"
    >
      <div v-if="!embedResults" class="concepts-title">
        <span v-show="!isMobile" class="concepts-title__text">
          概念列表（{{ allConceptsList.length }}）
        </span>
        <div class="add-concept">
          <el-select
            class="concepts-title-input"
            :size="isMini"
            v-model="newConcept"
            filterable
            remote
            clearable
            placeholder="搜索概念池"
            :remote-method="searchConcept"
            :loading="conceptSearchLoading"
          >
            <el-option
              v-for="item in conceptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button type="primary" :size="isMini" @click="addCustomConcept" :disabled="!newConcept.trim()">
            添加
          </el-button>
        </div>
      </div>
      <div class="attr-slots" :class="{ 'attr-slots--mobile': isMobile }">
        <div v-for="slot in visibleAttrSlots" :key="slot.key" class="attr-slot">
          <span class="attr-slot__label">{{ slot.label }}</span>
          <el-select
            :size="isMini"
            class="attr-slot__select"
            v-model="attrForm[slot.key]"
            filterable
            remote
            clearable
            allow-create
            default-first-option
            placeholder="可空"
            :remote-method="searchConcept"
            :loading="conceptSearchLoading"
            @change="onAttrSlotChange"
          >
            <el-option
              v-for="item in attrSelectOptions"
              :key="slot.key + '-' + item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div v-if="embedResults" class="attr-actions">
          <el-button :size="isMini" class="config-btn" @click="openAnalyzeConfig">配置</el-button>
          <el-button
            :size="isMini"
            class="analyze-btn"
            type="primary"
            :loading="analyzeLoading"
            :disabled="(embedDragonCards.length ? !pickedEmbedDragons.length : !selectedLeader) || analyzeLoading"
            @click="analyze()"
          >开始分析</el-button>
        </div>
      </div>
      <div v-if="!embedResults && allConceptsList.length" class="concepts-list">
        <div
          v-for="(conceptData, index) in allConceptsList"
          :key="(conceptData.name || '') + '-' + index"
          class="concept-item"
        >
          <el-badge
            v-if="conceptData.isCustom"
            class="concept-item-badge"
            value="A"
            type="danger"
          >
            <el-tag
              :size="isMini"
              :type="isConceptHighlighted(conceptData.name) ? 'danger' : ''"
              @click="toggleConcept(conceptData.name)"
              class="concept-tag"
            >
              {{ conceptData.name }}
            </el-tag>
          </el-badge>
          <el-badge
            v-else-if="showConceptCountBadge"
            class="concept-item-badge concept-item-badge--count"
            :value="conceptData.count"
            type="primary"
          >
            <el-tag
              :size="isMini"
              :type="isConceptHighlighted(conceptData.name) ? 'danger' : ''"
              class="concept-tag concept-tag--attr"
              @click.stop="openAttrAssignMenu($event, conceptData.name)"
            >
              {{ conceptData.name }}
            </el-tag>
          </el-badge>
          <el-tag
            v-else
            :size="isMini"
            :type="isConceptHighlighted(conceptData.name) ? 'danger' : ''"
            @click="toggleConcept(conceptData.name)"
            class="concept-tag"
          >
            {{ conceptData.name }}
          </el-tag>
        </div>
      </div>
      <div
        v-if="attrAssignMenu.visible"
        class="attr-assign-menu"
        :style="{ left: attrAssignMenu.x + 'px', top: attrAssignMenu.y + 'px' }"
        @click.stop
      >
        <div class="attr-assign-menu__title">填入「{{ attrAssignMenu.concept }}」</div>
        <button
          v-for="slot in menuAttrSlots"
          :key="'menu-' + slot.key"
          type="button"
          class="attr-assign-menu__item"
          @click="assignConceptToAttrSlot(slot.key)"
        >
          <span>{{ slot.label }}</span>
          <span v-if="attrForm[slot.key]" class="attr-assign-menu__cur">{{ attrForm[slot.key] }}</span>
        </button>
      </div>
    </div>

    <div class="results-area">
      <div v-if="isPickMode" class="pick-mode-banner">
        预首板回填 · {{ pickTradeDate }} · {{ pickOwnerLabel }}
      </div>
      <div class="results-area-filter">
        <div class="results-area-filter__controls">
          <el-button size="mini" @click="openFilterConfig">过滤配置</el-button>
          <el-checkbox v-model="filterMa250" @change="onFilterMa250Change">过滤MA250</el-checkbox>
          <el-checkbox v-model="filterSlope">分段斜率剔除 &gt; {{ slopeMinDisplay }}%</el-checkbox>
          <el-checkbox v-model="filterDistToYearHigh">距年高 ≤ {{ distToYearHighMaxDisplay }}%</el-checkbox>
          <div class="chip-tier-filter-row">
            <span class="filter-rel-vol-label">中期筹码</span>
            <div class="chip-tier-buttons">
              <button
                v-for="opt in midChipTierButtons"
                :key="'mid-' + opt.key"
                type="button"
                class="chip-tier-btn"
                :class="{ 'is-active': filterMidChipTiers.includes(opt.key) }"
                @click="toggleChipTier('filterMidChipTiers', opt.key)"
              >{{ opt.label }}</button>
            </div>
          </div>
        </div>
        <el-button
          v-if="embedResults && !isPickMode"
          size="mini"
          type="primary"
          class="sync-ths-btn"
          :loading="embedResults ? embedSyncLoading : syncThsLoading"
          :title="embedResults ? embedSyncTitle : '将当前结果写入「首板-简称」或「首板-简称(首个概念)」分组'"
          @click="onEmbedSyncClick"
        >同步同花顺</el-button>
        <button
          v-if="embedResults"
          type="button"
          class="preselect-select-all-btn"
          @click="selectAllFiltered"
        >全选</button>
        <button
          v-if="embedResults"
          type="button"
          class="preselect-add-btn"
          :class="{ on: embedPickActive }"
          @click="$emit('preselect-add')"
        >{{ embedPickActive ? '完成点选' : '添加' }}</button>
      </div>
      <div v-if="resultList.length && !isPickMode && !embedResults" class="results-toolbar">
        <el-button
          size="mini"
          type="primary"
          class="sync-ths-btn"
          :loading="syncThsLoading"
          @click="syncToThs"
        >
          同步同花顺
        </el-button>
        <span class="results-toolbar__hint">{{ pageTab === 'switch' ? '只写入师父的切换分组' : '将结果写入「首板-简称」或「首板-简称(首个概念)」分组' }}</span>
      </div>
      <el-table
        ref="resultTable"
        :data="showTableList"
        border
        style="width: 100%"
        :height="embedResults ? 480 : '100%'"
        :default-sort="{ prop: 'matchScore', order: 'descending' }"
        :row-class-name="embedRowClassName"
        @row-click="onEmbedTableRowClick"
        @sort-change="sortChange"
        @selection-change="onPickSelectionChange"
      >
        <el-table-column v-if="isPickMode" type="selection" width="48" fixed="left" />
        <el-table-column prop="name" label="股票名称" :min-width="!isComputer ? 90 : 120">
          <template slot-scope="{ row }">
            <span v-html="highlightMatchedText(row.name, row.matchedNames)"></span>
          </template>
        </el-table-column>
        <el-table-column prop="currentPrice" :sortable="'custom'" label="收盘价" :min-width="!isComputer ? 80 : 88" />
        <el-table-column
          prop="distToYearHighPct"
          :sortable="'custom'"
          label="距年高涨幅"
          :min-width="!isComputer ? 100 : 112"
          :formatter="fmtDistYearHigh"
        />
        <el-table-column
          prop="midChip"
          :sortable="'custom'"
          label="中期筹码分"
          :min-width="!isComputer ? 100 : 112"
          :formatter="formatChipPct"
        />
        <el-table-column
          prop="chipReviewScore"
          :sortable="'custom'"
          label="筹码排序分"
          :min-width="!isComputer ? 100 : 108"
        >
          <template slot-scope="{ row }">
            <div
              v-if="row.chipReviewScore != null"
              class="chip-review-cell"
              :class="chipReviewCellClass(row)"
            >
              <template v-if="row.chipReviewTier === 'S+'">
                <span class="chip-review-cell__mark">✦</span>
                <span class="chip-review-cell__score">{{ row.chipReviewScore }}</span>
                <span class="chip-review-cell__badge">S+</span>
                <span class="chip-review-cell__hint">核心筹码</span>
              </template>
              <template v-else>
                <span class="chip-review-cell__score">{{ row.chipReviewScore }}</span>
                <span class="chip-review-cell__tier">{{ row.chipReviewTier }}</span>
              </template>
            </div>
            <span v-else>—</span>
          </template>
        </el-table-column>
        <el-table-column prop="marketValue" :sortable="'custom'" :label="!isComputer ? '流通市值' : '流通市值(亿)'" :min-width="!isComputer ? 100 : 110" />
        <el-table-column prop="matchScore" :sortable="'custom'" label="概念分" :min-width="!isComputer ? 70 : 80" />
        <el-table-column
          prop="conceptDetails"
          label="概念详情"
          :min-width="firstBoardConceptColumnMinWidth"
          class-name="first-board-concepts-col"
        >
          <template slot-scope="{ row }">
            <div
              class="concept-details"
              :class="{ 'concept-details--h5-strip': isMobile }"
            >
              <el-tag
                v-for="concept in row.requiredMatchedConcepts"
                :key="`${row.code}-${concept}-r`"
                type="danger"
                size="mini"
              >
                {{ concept }}
              </el-tag>
              <el-tag
                v-for="concept in row.matchedConcepts"
                :key="`${row.code}-${concept}-m`"
                size="mini"
              >
                {{ concept }}
              </el-tag>
              <el-tag
                v-for="concept in row.selectedMatchedConcepts"
                :key="`${row.code}-${concept}-s`"
                type="warning"
                size="mini"
              >
                {{ concept }}(+5)
              </el-tag>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="isPickMode" class="pick-mode-footer">
        <span class="pick-mode-footer__hint">已选 {{ pickSelectedRows.length }} 只</span>
        <el-button type="primary" :loading="pickSaveLoading" :disabled="!pickSelectedRows.length" @click="savePickAndReturn">
          保存并返回
        </el-button>
      </div>
    </div>
    <el-dialog title="过滤配置" :visible.sync="filterConfigVisible" width="560px" append-to-body>
      <p class="tip">
        短 / 中 / 长分界值中，<b>中期</b>用于四档点选：C0 / C1 / C2(13–20%，含20) / 无档(&gt;20% 及无值等)；C0/C1 分界默认 5 / 10。
      </p>
      <div v-for="item in rangeFields" :key="item.key" class="band-row">
        <span class="band-idx">{{ item.label }}</span>
        <el-input v-model="rangeDraft[item.key].a" placeholder="a" size="mini" style="width: 80px" />
        <span class="band-sep">/</span>
        <el-input v-model="rangeDraft[item.key].b" placeholder="b" size="mini" style="width: 80px" />
        <span class="band-sep">/</span>
        <el-input v-model="rangeDraft[item.key].c" placeholder="c" size="mini" style="width: 80px" />
        <span class="unit">%</span>
      </div>
      <p class="tip" style="margin-top: 16px">
        分段斜率（展示为原始值×1000%）：勾选后剔除斜率 &gt; 该阈值的票（默认 10，对应原始 0.01）。
      </p>
      <div class="band-row">
        <span class="band-idx">剔除&gt;</span>
        <el-input v-model="rangeDraft.slopeMin" placeholder="10" size="mini" style="width: 120px" />
        <span class="unit">%（×1000）</span>
      </div>
      <p class="tip" style="margin-top: 16px">
        距年高涨幅：勾选后保留「(年高-收盘)/收盘×100」≤ 该阈值的票（默认 15）。
      </p>
      <div class="band-row">
        <span class="band-idx">距年高≤</span>
        <el-input v-model="rangeDraft.distToYearHighMax" placeholder="15" size="mini" style="width: 120px" />
        <span class="unit">%</span>
      </div>
      <div slot="footer">
        <el-button size="small" @click="resetFilterConfig">恢复默认</el-button>
        <el-button size="small" @click="filterConfigVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="saveFilterConfig">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { stockApi } from '@/api/stockApi'
import { passesMa250Filter } from '@/views/GapUpAnalysis/assets/js/ma250Filter'
import {
  RANGE_FIELDS,
  loadRangeConfig,
  saveRangeConfig,
  cloneRangeConfig,
  defaultRangeConfig,
  parsePct,
  midChipTierButtonDefs,
  passesMidChipTierFilter,
  slopeThresholdRaw
} from '@/utils/hfbChipFilters'
import { BREAKPOINTS } from '@/utils/device'
import {
  CONCEPT_SOURCE_OPTIONS,
  CONCEPT_SOURCE_MERGE,
  resolveConceptsBySource
} from '@/utils/conceptSource'
import { filterAnalysisConcepts } from '@/utils/conceptFilter'
import { isChiNextBoard } from '@/utils/limitUpFilters'
import { attachChipReviewScoreV1 } from '@/utils/chipReviewScoreV1'
import { formatDate } from '@/utils/index'

const ANALYZE_CONFIG_STORAGE_KEY = 'firstBoardPreselectionAnalyzeConfig'
const SWITCH_CHIP_STORAGE_KEY = 'switchPreselectMaxMidChipPct'
const DEFAULT_ANALYZE_CONFIG = {
  maxPrice: 30,
  minMarketCapYi: 0,
  maxMarketCapYi: 60,
  resultLimit: 50
}
const ATTR_SLOT_DEFS = [
  { key: 'attrMain', label: '主属性1' },
  { key: 'attrMain2', label: '主属性2' },
  { key: 'attrMain3', label: '主属性3' },
  { key: 'attrSub1', label: '副属性1' },
  { key: 'attrSub2', label: '副属性2' },
  { key: 'attrSub3', label: '副属性3' }
]
const EMPTY_ATTR_FORM = () => ({
  attrMain: '',
  attrMain2: '',
  attrMain3: '',
  attrSub1: '',
  attrSub2: '',
  attrSub3: ''
})

export default {
  name: 'FirstBoardPreselection',
  props: {
    /** 龙头指挥中心内嵌：隐藏龙头/参考日，主属性由外部传入 */
    embedResults: { type: Boolean, default: false },
    tradeDate: { type: String, default: '' },
    embedLeader: { type: Object, default: null },
    embedDragonCards: { type: Array, default: () => [] },
    embedDragonSelected: { type: Array, default: () => [] },
    embedMainAttrs: { type: Array, default: () => [] },
    embedBuZhang: { type: Array, default: () => [] },
    embedSubAttrs: { type: Object, default: () => ({}) },
    embedPickActive: { type: Boolean, default: false },
    embedPickedCodes: { type: Array, default: () => [] },
    embedSyncLoading: { type: Boolean, default: false },
    embedSyncTitle: { type: String, default: '' },
    /** main=只主板；chinext=只创业板。空则沿用页面上的勾选。 */
    boardLock: { type: String, default: '' }
  },
  data() {
    const rangeConfig = loadRangeConfig()
    return {
      isMobile: false,
      isTablet: false,
      showContent: false,
      pageTab: 'first',
      switchMain1: '',
      switchMain2: '',
      switchBacktestDate: formatDate(new Date()),
      maxMidChipPct: '5',
      conceptSource: CONCEPT_SOURCE_MERGE,
      conceptSourceOptions: CONCEPT_SOURCE_OPTIONS,
      selectedLeader: null,
      onlyChiNext: false,
      leaderFreeFloatYi: null,
      leaderClosePrice: null,
      leaderFirstLimitUpDate: '',
      leaderFreeFloatLoading: false,
      leaderFreeFloatSeq: 0,
      selectedBuZhang1: null,
      selectedBuZhang2: null,
      selectedBuZhang3: null,
      /** 主属性任一非空时进入属性匹配模式 */
      attrForm: EMPTY_ATTR_FORM(),
      attrSlotDefs: ATTR_SLOT_DEFS,
      attrAssignMenu: { visible: false, x: 0, y: 0, concept: '' },
      attrMenuIgnoreCloseUntil: 0,
      stockOptions: [],
      searchLoading: false,
      /** @type {Array<{ name: string, count: number }>} 概念并集（按出现次数降序） */
      conceptsList: [],
      newConcept: '',
      customConcepts: [],
      conceptOptions: [],
      conceptSearchLoading: false,
      selectedConcepts: [],
      resultList: [],
      // 过滤 MA250（首板口径：收盘价×1.1² > MA250）
      filterMa250: true,
      filterSlope: true,
      filterDistToYearHigh: false,
      rangeFields: RANGE_FIELDS,
      rangeConfig,
      rangeDraft: cloneRangeConfig(rangeConfig),
      filterConfigVisible: false,
      filterMidChipTiers: [],
      refDate: formatDate(new Date()),
      pickSelectedRows: [],
      pickSaveLoading: false,
      syncThsLoading: false,
      analyzeLoading: false,
      sortProp: 'matchScore',
      sortOrder: 'descending',
      configDialogVisible: false,
      /** 已生效的分析参数（传给后端） */
      analyzeConfig: { ...DEFAULT_ANALYZE_CONFIG },
      /** 弹窗内编辑副本（字符串，仅数字） */
      configDraft: {
        maxPrice: '30',
        minMarketCapYi: '0',
        maxMarketCapYi: '60',
        resultLimit: '50',
        maxMidChipPct: '5'
      }
    }
  },
  computed: {
    isMini() {
      return this.isMobile ? 'mini' : ''
    },
    isComputer() {
      return !this.isMobile && !this.isTablet
    },
    distToYearHighMaxDisplay() {
      const n = Number(this.rangeConfig && this.rangeConfig.distToYearHighMax)
      return Number.isFinite(n) ? n : 15
    },
    distToYearHighMaxValue() {
      const n = Number(this.rangeConfig && this.rangeConfig.distToYearHighMax)
      return Number.isFinite(n) ? n : 15
    },
    slopeMinDisplay() {
      const n = Number(this.rangeConfig && this.rangeConfig.slopeMin)
      return Number.isFinite(n) ? n : 10
    },
    slopeMinValue() {
      const n = Number(this.rangeConfig && this.rangeConfig.slopeMin)
      return Number.isFinite(n) ? n : 10
    },
    midChipTierButtons() {
      return midChipTierButtonDefs(this.rangeConfig && this.rangeConfig.mid)
    },
    hasBuZhangOverlay() {
      return !!(this.selectedBuZhang1 || this.selectedBuZhang2 || this.selectedBuZhang3)
    },
    leaderFreeFloatText() {
      if (!this.selectedLeader) return '—'
      if (this.leaderFreeFloatLoading) return '…'
      const n = Number(this.leaderFreeFloatYi)
      if (!Number.isFinite(n)) return '—'
      return `${n.toFixed(2)}亿`
    },
    leaderClosePriceText() {
      if (!this.selectedLeader) return '—'
      if (this.leaderFreeFloatLoading) return '…'
      const n = Number(this.leaderClosePrice)
      if (!Number.isFinite(n)) return '—'
      return `${n.toFixed(2)}`
    },
    leaderFreeFloatTitle() {
      if (this.leaderFirstLimitUpDate) {
        return `参考日近15交易日内首次涨停日 ${this.leaderFirstLimitUpDate} 的收盘价与自由流通市值`
      }
      return '参考日近15交易日内首次涨停日的收盘价与自由流通市值'
    },
    /** 远程结果 + 当前已选，避免共用 options 刷新后补涨/龙头显示变空 */
    stockSelectOptions() {
      const seen = new Set()
      const out = []
      const push = (item) => {
        if (!item || item.value == null || item.value === '') return
        const key = String(item.value)
        if (seen.has(key)) return
        seen.add(key)
        out.push(item)
      }
      ;[
        this.selectedLeader,
        this.selectedBuZhang1,
        this.selectedBuZhang2,
        this.selectedBuZhang3
      ].forEach(push)
      ;(this.stockOptions || []).forEach(push)
      return out
    },
    showConceptCountBadge() {
      return this.hasBuZhangOverlay
    },
    visibleAttrSlots() {
      if (!this.embedResults) return this.attrSlotDefs
      return this.attrSlotDefs.filter((slot) => String(slot.key).indexOf('attrSub') === 0)
    },
    menuAttrSlots() {
      return this.visibleAttrSlots
    },
    embedMainAttrKey() {
      return (this.embedMainAttrs || []).map((s) => String(s || '').trim()).join('\u0001')
    },
    embedBuZhangKey() {
      return (this.embedBuZhang || [])
        .map((s) => (s && (s.code || s.value)) || '')
        .join('|')
    },
    embedSubAttrKey() {
      const src = this.embedSubAttrs || {}
      return ['attrSub1', 'attrSub2', 'attrSub3'].map((key) => String(src[key] || '').trim()).join('\u0001')
    },
    switchConceptOptions() {
      const seen = new Set()
      const out = []
      const push = (name) => {
        const n = String(name || '').trim()
        if (!n || seen.has(n)) return
        seen.add(n)
        out.push({ value: n, label: n })
      }
      push(this.switchMain1)
      push(this.switchMain2)
      ;(this.conceptOptions || []).forEach((item) => push(item.value || item.label))
      return out
    },
    attrSelectOptions() {
      const seen = new Set()
      const out = []
      const push = (name) => {
        const n = String(name || '').trim()
        if (!n || seen.has(n)) return
        seen.add(n)
        out.push({ value: n, label: n })
      }
      ATTR_SLOT_DEFS.forEach((slot) => push(this.attrForm[slot.key]))
      ;(this.conceptsList || []).forEach((item) => push(item.name))
      ;(this.customConcepts || []).forEach((item) => push(item.name))
      ;(this.conceptOptions || []).forEach((item) => push(item.value || item.label))
      return out
    },
    buZhangCustomConcepts() {
      const names = new Set()
      for (const stock of [this.selectedBuZhang1, this.selectedBuZhang2, this.selectedBuZhang3]) {
        if (!stock) continue
        const concepts = filterAnalysisConcepts(
          resolveConceptsBySource(stock.concepts, stock.kplConcepts, this.conceptSource, stock.localConcepts)
        )
        concepts.forEach((c) => names.add(c))
      }
      return [...names]
    },
    /** 与补涨分析一致：H5 概念列宽 + 单元格内横滑 */
    firstBoardConceptColumnMinWidth() {
      if (this.isMobile) return 280
      if (!this.isComputer) return 220
      return 200
    },
    showTableList() {
      let list = this.resultList || []
      const hasMidTier = this.filterMidChipTiers && this.filterMidChipTiers.length
      if (!this.filterMa250 && !this.filterSlope && !this.filterDistToYearHigh && !hasMidTier) {
        return this.sortTableData(list)
      }
      list = list.filter((row) => {
        if (this.filterMa250) {
          if (
            !passesMa250Filter({
              firstBoardPrice: row.firstBoardPrice ?? row.currentPrice,
              maMax: row.maMax,
              ma250: row.ma250,
              ma10: row.ma10,
              ma20: row.ma20,
              ma30: row.ma30,
              ma40: row.ma40,
              ma60: row.ma60,
              ma110: row.ma110,
              ma120: row.ma120,
              ma160: row.ma160,
              ma210: row.ma210
            })
          ) {
            return false
          }
        }
        if (this.filterSlope) {
          const thr = slopeThresholdRaw(this.slopeMinValue)
          const v = Number(row.chipSlope)
          if (Number.isFinite(v) && v > thr) return false
        }
        if (this.filterDistToYearHigh) {
          const v = Number(row.distToYearHighPct)
          if (!Number.isFinite(v) || v > this.distToYearHighMaxValue) return false
        }
        if (!passesMidChipTierFilter(row.midChip, this.filterMidChipTiers, this.rangeConfig.mid)) {
          return false
        }
        return true
      })
      return this.sortTableData(list)
    },
    allConceptsList() {
      const baseNames = new Set((this.conceptsList || []).map((x) => x.name))
      const custom = this.customConcepts
        .filter((item) => !baseNames.has(item.name))
        .map((item) => ({ name: item.name, isCustom: true, count: null }))
      const fromUnion = (this.conceptsList || []).map((item) => ({
        name: item.name,
        isCustom: false,
        count: item.count
      }))
      return [...custom, ...fromUnion]
    },
    isPickMode() {
      return this.$route.query.mode === 'pick'
    },
    pickTradeDate() {
      return String(this.$route.query.tradeDate || '').trim()
    },
    pickOwner() {
      return this.$route.query.owner === '2' ? '2' : '1'
    },
    pickedEmbedDragons() {
      const picked = new Set(this.embedDragonSelected || [])
      return (this.embedDragonCards || []).filter((card) => card && picked.has(card.key))
    },
    pickOwnerLabel() {
      return this.pickOwner === '2' ? '小鱼' : '师父'
    }
  },
  watch: {
    tradeDate: {
      immediate: true,
      handler(next) {
        if (!this.embedResults) return
        const date = String(next || '').trim()
        if (!date || date === this.refDate) return
        this.refDate = date
        if (this.selectedLeader) {
          this.refreshLeaderFreeFloat()
          this.resultList = []
        }
      }
    },
    embedLeader: {
      immediate: true,
      handler(next) {
        if (!this.embedResults) return
        if ((this.embedDragonCards || []).length) {
          if (!this._dragonEmbedBooted) {
            this._dragonEmbedBooted = true
            this.syncEmbedLeader()
          } else {
            this.syncSelectedDragonMeta()
          }
          return
        }
        const nc = this.normEmbedCode(next && (next.code || next.value || next.leaderId))
        const pc = this.normEmbedCode(this.selectedLeader && this.selectedLeader.value)
        if (nc && nc === pc && this.selectedLeader) {
          this.applyEmbedSubAttrs()
          return
        }
        this.syncEmbedLeader()
      }
    },
    embedDragonSelected() {
      if (!this.embedResults || !(this.embedDragonCards || []).length || !this._dragonEmbedBooted) return
      this.syncSelectedDragonMeta()
    },
    embedSubAttrKey(next, prev) {
      if (!this.embedResults || next === prev || this._embedSyncing) return
      this.applyEmbedSubAttrs()
    },
    embedMainAttrKey(next, prev) {
      if (!this.embedResults || next === prev || this._embedSyncing) return
      if (this.applyEmbedMainAttrs()) this.resultList = []
    },
    embedBuZhangKey(next, prev) {
      if (!this.embedResults || next === prev || this._embedSyncing) return
      this.applyEmbedBuZhang()
    }
  },
  methods: {
    checkScreenSize() {
      const width = window.innerWidth
      this.isMobile = width <= BREAKPOINTS.MOBILE
      this.isTablet = width > BREAKPOINTS.MOBILE && width <= BREAKPOINTS.TABLET
      this.showContent = true
    },
    async searchStock(query) {
      if (!String(query || '').trim()) {
        this.stockOptions = []
        return
      }
      this.searchLoading = true
      try {
        const response = await stockApi.searchStocks(query)
        if (response.success && response.data) {
          this.stockOptions = response.data.map(stock => ({
            value: stock.code,
            label: `${stock.name} (${stock.code})`,
            name: stock.name,
            concepts: Array.isArray(stock.concepts) ? stock.concepts : [],
            kplConcepts: Array.isArray(stock.kplConcepts) ? stock.kplConcepts : [],
            localConcepts: Array.isArray(stock.localConcepts) ? stock.localConcepts : []
          }))
        } else {
          this.stockOptions = []
        }
      } catch (error) {
        this.$message.error('搜索失败')
      } finally {
        this.searchLoading = false
      }
    },
    onConceptSourceChange() {
      this.selectedLeader = null
      this.selectedBuZhang1 = null
      this.selectedBuZhang2 = null
      this.selectedBuZhang3 = null
      this.attrForm = EMPTY_ATTR_FORM()
      this.closeAttrAssignMenu()
      this.stockOptions = []
      this.conceptsList = []
      this.customConcepts = []
      this.newConcept = ''
      this.conceptOptions = []
      this.selectedConcepts = []
      this.resultList = []
    },
    stockConceptNames(stock) {
      if (!stock) return []
      return filterAnalysisConcepts(
        resolveConceptsBySource(stock.concepts, stock.kplConcepts, this.conceptSource, stock.localConcepts)
      )
    },
    rebuildConceptsList() {
      const stocks = []
      if (this.selectedLeader) stocks.push(this.selectedLeader)
      if (this.selectedBuZhang1) stocks.push(this.selectedBuZhang1)
      if (this.selectedBuZhang2) stocks.push(this.selectedBuZhang2)
      if (this.selectedBuZhang3) stocks.push(this.selectedBuZhang3)
      if (!stocks.length) {
        this.conceptsList = []
        return
      }
      const countMap = new Map()
      for (const stock of stocks) {
        const seen = new Set()
        for (const name of this.stockConceptNames(stock)) {
          if (seen.has(name)) continue
          seen.add(name)
          countMap.set(name, (countMap.get(name) || 0) + 1)
        }
      }
      this.conceptsList = [...countMap.entries()]
        .map(([name, count]) => ({ name, count }))
        .sort(
          (a, b) =>
            b.count - a.count || String(a.name).localeCompare(String(b.name), 'zh-CN')
        )
      const keep = new Set(this.conceptsList.map((x) => x.name))
      this.selectedConcepts = (this.selectedConcepts || []).filter((n) => keep.has(n))
      this.emitEmbedConcepts()
    },
    handleLeaderChange(leader) {
      this.resultList = []
      this.attrForm = EMPTY_ATTR_FORM()
      this.closeAttrAssignMenu()
      this.onlyChiNext = this.lockedOnlyChiNext(leader && (leader.value || leader.code))
      this.refreshLeaderFreeFloat()
      if (!leader) {
        this.conceptsList = []
        this.customConcepts = []
        this.newConcept = ''
        this.conceptOptions = []
        this.selectedConcepts = []
        if (!this.hasBuZhangOverlay) return
      }
      this.customConcepts = []
      this.newConcept = ''
      this.conceptOptions = []
      this.rebuildConceptsList()
      if (!leader) this.selectedConcepts = []
    },
    onRefDateChange() {
      this.refreshLeaderFreeFloat()
    },
    async refreshLeaderFreeFloat() {
      const code = this.selectedLeader && (this.selectedLeader.value || this.selectedLeader.code)
      if (!code) {
        this.leaderFreeFloatYi = null
        this.leaderClosePrice = null
        this.leaderFirstLimitUpDate = ''
        this.leaderFreeFloatLoading = false
        return
      }
      const seq = ++this.leaderFreeFloatSeq
      this.leaderFreeFloatLoading = true
      try {
        const res = await stockApi.getFirstBoardLeaderFreeFloat(code, this.refDate || '')
        if (seq !== this.leaderFreeFloatSeq) return
        if (!res || !res.ok) {
          this.leaderFreeFloatYi = null
          this.leaderClosePrice = null
          this.leaderFirstLimitUpDate = ''
          return
        }
        this.leaderFreeFloatYi =
          res.freeFloatMarketCapYi != null && Number.isFinite(Number(res.freeFloatMarketCapYi))
            ? Number(res.freeFloatMarketCapYi)
            : null
        this.leaderClosePrice =
          res.closePrice != null && Number.isFinite(Number(res.closePrice))
            ? Number(res.closePrice)
            : null
        this.leaderFirstLimitUpDate = res.firstLimitUpDate || ''
        if (res.refDate && !this.refDate) this.refDate = res.refDate
      } catch (e) {
        if (seq !== this.leaderFreeFloatSeq) return
        this.leaderFreeFloatYi = null
        this.leaderClosePrice = null
        this.leaderFirstLimitUpDate = ''
      } finally {
        if (seq === this.leaderFreeFloatSeq) this.leaderFreeFloatLoading = false
        this.emitEmbedLeaderMeta()
      }
    },
    handleBuZhangChange() {
      this.resultList = []
      this.rebuildConceptsList()
    },
    onAttrSlotChange() {
      this.resultList = []
      this.emitEmbedSubAttrs()
    },
    isConceptInAttrSlots(name) {
      const n = String(name || '').trim()
      if (!n) return false
      return ATTR_SLOT_DEFS.some((slot) => String(this.attrForm[slot.key] || '').trim() === n)
    },
    isConceptHighlighted(name) {
      return this.selectedConcepts.includes(name) || this.isConceptInAttrSlots(name)
    },
    openAttrAssignMenu(evt, conceptName) {
      const n = String(conceptName || '').trim()
      if (!n) return
      // 再次点击同一概念：关闭下拉
      if (this.attrAssignMenu.visible && this.attrAssignMenu.concept === n) {
        this.forceCloseAttrAssignMenu()
        return
      }
      let x = 12
      let y = 12
      if (evt) {
        const rect =
          evt.currentTarget && typeof evt.currentTarget.getBoundingClientRect === 'function'
            ? evt.currentTarget.getBoundingClientRect()
            : null
        if (rect) {
          x = rect.left
          y = rect.bottom + 4
        } else if (evt.clientX != null) {
          x = evt.clientX
          y = evt.clientY
        }
      }
      const left = Math.min(Number(x) || 12, window.innerWidth - 220)
      const top = Math.min(Number(y) || 12, window.innerHeight - 300)
      this.attrMenuIgnoreCloseUntil = Date.now() + 50
      this.attrAssignMenu = {
        visible: true,
        x: Math.max(8, left),
        y: Math.max(8, top),
        concept: n
      }
    },
    closeAttrAssignMenu(e) {
      if (this.attrMenuIgnoreCloseUntil && Date.now() < this.attrMenuIgnoreCloseUntil) return
      if (e && e.target && typeof e.target.closest === 'function') {
        if (e.target.closest('.attr-assign-menu')) return
        if (e.target.closest('.concept-tag--attr')) return
      }
      if (this.attrAssignMenu && this.attrAssignMenu.visible) {
        this.attrAssignMenu = { visible: false, x: 0, y: 0, concept: '' }
      }
    },
    forceCloseAttrAssignMenu() {
      this.attrMenuIgnoreCloseUntil = 0
      this.attrAssignMenu = { visible: false, x: 0, y: 0, concept: '' }
    },
    assignConceptToAttrSlot(slotKey) {
      const n = String(this.attrAssignMenu.concept || '').trim()
      if (!n || !slotKey) return
      this.$set(this.attrForm, slotKey, n)
      this.resultList = []
      this.forceCloseAttrAssignMenu()
      this.emitEmbedSubAttrs()
    },
    setEmbedSubAttr(slotKey, name) {
      if (!this.embedResults) return
      if (!['attrSub1', 'attrSub2', 'attrSub3'].includes(slotKey)) return
      this.$set(this.attrForm, slotKey, String(name || '').trim())
      this.resultList = []
      this.emitEmbedSubAttrs()
    },
    emitEmbedConcepts() {
      if (!this.embedResults) return
      const list = (this.conceptsList || []).filter((item) => Number(item && item.count) >= 2)
      this.$emit('embed-concepts', list)
    },
    emitEmbedSubAttrs() {
      if (!this.embedResults) return
      this.$emit('embed-sub-attrs', {
        attrSub1: this.attrForm.attrSub1 || '',
        attrSub2: this.attrForm.attrSub2 || '',
        attrSub3: this.attrForm.attrSub3 || ''
      })
    },
    emitEmbedLeaderMeta() {
      if (!this.embedResults) return
      this.$emit('embed-leader-meta', {
        priceText: this.leaderClosePriceText,
        ffText: this.leaderFreeFloatText,
        title: this.leaderFreeFloatTitle
      })
    },
    applyEmbedSubAttrs() {
      if (!this.embedResults) return
      const src = this.embedSubAttrs || {}
      ;['attrSub1', 'attrSub2', 'attrSub3'].forEach((key) => {
        const next = String(src[key] || '').trim()
        if ((this.attrForm[key] || '') !== next) this.$set(this.attrForm, key, next)
      })
    },
    applyEmbedMainAttrs() {
      const names = (this.embedMainAttrs || []).map((s) => String(s || '').trim())
      const keys = ['attrMain', 'attrMain2', 'attrMain3']
      let changed = false
      keys.forEach((key, index) => {
        const next = names[index] || ''
        if ((this.attrForm[key] || '') !== next) {
          this.$set(this.attrForm, key, next)
          changed = true
        }
      })
      return changed
    },
    normEmbedCode(code) {
      const digits = String(code || '').replace(/\D/g, '')
      if (!digits) return ''
      return digits.slice(-6).padStart(6, '0')
    },
    async lookupStock(raw) {
      const code = this.normEmbedCode(raw && (raw.code || raw.value || raw.leaderId))
      const name = String((raw && raw.name) || '').trim()
      if (!code || code === '000000') return null
      const queries = []
      if (name) queries.push(name)
      queries.push(code)
      for (const query of queries) {
        try {
          const response = await stockApi.searchStocks(query)
          const list = (response && response.success && response.data) || []
          const hit = list.find((s) => this.normEmbedCode(s.code) === code)
          if (!hit) continue
          return {
            value: hit.code,
            label: `${hit.name} (${hit.code})`,
            name: hit.name,
            concepts: Array.isArray(hit.concepts) ? hit.concepts : [],
            kplConcepts: Array.isArray(hit.kplConcepts) ? hit.kplConcepts : [],
            localConcepts: Array.isArray(hit.localConcepts) ? hit.localConcepts : []
          }
        } catch (err) {
          /* 下一查询 */
        }
      }
      return null
    },
    async applyEmbedBuZhang() {
      if (!this.embedResults || this._embedSyncing) return
      const seq = (this._buZhangSeq || 0) + 1
      this._buZhangSeq = seq
      const slots = [null, null, null]
      const list = this.embedBuZhang || []
      for (let i = 0; i < 3; i++) {
        const item = list[i]
        if (!item || !(item.code || item.value)) continue
        slots[i] = await this.lookupStock(item)
        if (seq !== this._buZhangSeq) return
      }
      this.selectedBuZhang1 = slots[0]
      this.selectedBuZhang2 = slots[1]
      this.selectedBuZhang3 = slots[2]
      this.rebuildConceptsList()
      this.resultList = []
    },
    async syncSelectedDragonMeta() {
      const card = (this.pickedEmbedDragons || [])[0]
      if (!card) return
      const hit = await this.lookupStock(card)
      if (!hit) return
      const prev = this.normEmbedCode(this.selectedLeader && this.selectedLeader.value)
      const next = this.normEmbedCode(hit.value)
      this.selectedLeader = hit
      if (prev !== next) this.refreshLeaderFreeFloat()
    },
    async syncEmbedLeader() {
      if (!this.embedResults) return
      const seq = (this._embedLeaderSeq || 0) + 1
      this._embedLeaderSeq = seq
      const date = String(this.tradeDate || '').trim()
      if (date) this.refDate = date
      const primary = (this.pickedEmbedDragons || [])[0] || this.embedLeader
      const hit = await this.lookupStock(primary)
      if (seq !== this._embedLeaderSeq) return
      if (!hit) {
        this.selectedLeader = null
        this.emitEmbedLeaderMeta()
        return
      }
      this._embedSyncing = true
      try {
        const prev = this.normEmbedCode(this.selectedLeader && this.selectedLeader.value)
        const next = this.normEmbedCode(hit.value)
        if (prev !== next) {
          this.attrForm = EMPTY_ATTR_FORM()
        }
        this.selectedLeader = hit
        this.onlyChiNext = this.lockedOnlyChiNext(hit.value || hit.code)
        this.applyEmbedMainAttrs()
        this.applyEmbedSubAttrs()
        this.refreshLeaderFreeFloat()
        await this.applyEmbedBuZhangForce(seq)
        if (seq !== this._embedLeaderSeq) return
        this.rebuildConceptsList()
        this.resultList = []
      } finally {
        if (seq === this._embedLeaderSeq) this._embedSyncing = false
      }
    },
    async applyEmbedBuZhangForce() {
      const slots = [null, null, null]
      const list = this.embedBuZhang || []
      for (let i = 0; i < 3; i++) {
        const item = list[i]
        if (!item || !(item.code || item.value)) continue
        slots[i] = await this.lookupStock(item)
      }
      this.selectedBuZhang1 = slots[0]
      this.selectedBuZhang2 = slots[1]
      this.selectedBuZhang3 = slots[2]
    },
    async searchConcept(query) {
      if (!String(query || '').trim()) {
        this.conceptOptions = []
        return
      }
      this.conceptSearchLoading = true
      try {
        const response = await stockApi.searchConcepts(query)
        if (response.success && Array.isArray(response.data)) {
          this.conceptOptions = response.data.map((name) => ({
            value: name,
            label: name
          }))
        } else {
          this.conceptOptions = []
        }
      } catch (_error) {
        this.conceptOptions = []
      } finally {
        this.conceptSearchLoading = false
      }
    },
    addCustomConcept() {
      const concept = this.newConcept.trim()
      if (!concept) return
      const exists =
        (this.conceptsList || []).some((item) => item.name === concept) ||
        this.customConcepts.some((item) => item.name === concept)
      if (exists) return
      this.customConcepts.push({ name: concept, isCustom: true })
      this.newConcept = ''
      this.conceptOptions = []
    },
    toggleConcept(concept) {
      const idx = this.selectedConcepts.indexOf(concept)
      if (idx > -1) {
        this.selectedConcepts.splice(idx, 1)
      } else {
        this.selectedConcepts.push(concept)
      }
    },
    formatChipPct(row, column, cellValue) {
      if (cellValue == null || cellValue === '') return '-'
      const n = Number(cellValue)
      if (!Number.isFinite(n)) return '-'
      return `${(n * 100).toFixed(2)}%`
    },
    chipReviewCellClass(row) {
      const t = row && row.chipReviewTier
      if (t === 'S+') return 'chip-review-cell--splus'
      if (t === 'S') return 'chip-review-cell--s'
      if (t === 'A') return 'chip-review-cell--a'
      if (t === 'B') return 'chip-review-cell--b'
      return ''
    },
    fmtDistYearHigh(_r, _c, v) {
      if (v == null || v === '') return '-'
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${n.toFixed(2)}%`
    },
    openFilterConfig() {
      this.rangeDraft = cloneRangeConfig(this.rangeConfig)
      this.filterConfigVisible = true
    },
    resetFilterConfig() {
      this.rangeDraft = defaultRangeConfig()
    },
    saveFilterConfig() {
      const next = cloneRangeConfig(this.rangeDraft)
      for (const f of RANGE_FIELDS) {
        const aPct = parsePct(next[f.key].a)
        const bPct = parsePct(next[f.key].b)
        const cPct = parsePct(next[f.key].c)
        if (aPct == null || bPct == null || cPct == null) {
          this.$message.warning(`${f.label}请填写三个分界值`)
          return
        }
        if (!(aPct < bPct && bPct < cPct)) {
          this.$message.warning(`${f.label}须满足 a < b < c`)
          return
        }
      }
      const slopeMin = Number(next.slopeMin)
      if (!Number.isFinite(slopeMin)) {
        this.$message.warning('分段斜率阈值须为数字')
        return
      }
      const distMax = Number(next.distToYearHighMax)
      if (!Number.isFinite(distMax)) {
        this.$message.warning('距年高阈值须为数字')
        return
      }
      next.slopeMin = String(slopeMin)
      next.slopeUnit = 'x1000pct'
      next.distToYearHighMax = String(distMax)
      this.rangeConfig = next
      saveRangeConfig(next)
      this.filterConfigVisible = false
      this.$message.success('过滤配置已保存')
    },
    toggleChipTier(field, tierKey) {
      const cur = Array.isArray(this[field]) ? [...this[field]] : []
      const i = cur.indexOf(tierKey)
      if (i >= 0) cur.splice(i, 1)
      else cur.push(tierKey)
      this[field] = cur
    },
    onFilterMa250Change(checked) {
      if (!checked) return
      const hasMa250 = (this.resultList || []).some((row) => row.ma250 != null)
      if (!hasMa250) {
        this.$message.warning('当前结果暂无 MA250，请确认参考日日线已同步（均线由日线收盘现算）')
        this.filterMa250 = false
      }
    },
    highlightMatchedText(text, matchedChars) {
      if (!text || !Array.isArray(matchedChars) || matchedChars.length === 0) return text
      let result = String(text)
      matchedChars.forEach(char => {
        const escaped = String(char).replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const regex = new RegExp(`(${escaped})`, 'g')
        result = result.replace(regex, '<span class="highlight-name">$1</span>')
      })
      return result
    },
    sortChange({ prop, order }) {
      this.sortProp = prop || ''
      this.sortOrder = order || ''
    },
    sortTableData(data) {
      const list = Array.isArray(data) ? [...data] : []
      if (!this.sortProp || !this.sortOrder) return list
      return list.sort((a, b) => {
        const av = Number(a[this.sortProp])
        const bv = Number(b[this.sortProp])
        if (!Number.isFinite(av) && !Number.isFinite(bv)) return 0
        if (!Number.isFinite(av)) return 1
        if (!Number.isFinite(bv)) return -1
        return this.sortOrder === 'descending' ? bv - av : av - bv
      })
    },
    loadAnalyzeConfigFromStorage() {
      try {
        const raw = localStorage.getItem(ANALYZE_CONFIG_STORAGE_KEY)
        if (!raw) return { ...DEFAULT_ANALYZE_CONFIG }
        const parsed = JSON.parse(raw)
        const normalized = this.normalizeAnalyzeConfig(parsed)
        return normalized || { ...DEFAULT_ANALYZE_CONFIG }
      } catch (_e) {
        return { ...DEFAULT_ANALYZE_CONFIG }
      }
    },
    saveAnalyzeConfigToStorage(config) {
      try {
        localStorage.setItem(ANALYZE_CONFIG_STORAGE_KEY, JSON.stringify(config))
      } catch (_e) {
        /* ignore quota / private mode */
      }
    },
    loadSwitchChipCap() {
      try {
        const raw = localStorage.getItem(SWITCH_CHIP_STORAGE_KEY)
        if (raw == null) return '5'
        return String(raw)
      } catch (_e) {
        return '5'
      }
    },
    saveSwitchChipCap(value) {
      this.maxMidChipPct = value
      try {
        localStorage.setItem(SWITCH_CHIP_STORAGE_KEY, value)
      } catch (_e) {
        /* ignore quota / private mode */
      }
    },
    onConfigChipInput(value) {
      const text = String(value || '').replace(/[^\d.]/g, '')
      const parts = text.split('.')
      this.configDraft.maxMidChipPct = parts.length > 1
        ? `${parts[0]}.${parts.slice(1).join('').slice(0, 2)}`
        : parts[0]
    },
    parsedMaxMidChipPct() {
      const text = String(this.maxMidChipPct || '').trim()
      if (!text) return null
      const n = Number(text)
      if (!Number.isFinite(n) || n <= 0) return null
      return n
    },
    normalizeAnalyzeConfig(input) {
      const price = Number(input?.maxPrice)
      const minCap = Number(input?.minMarketCapYi)
      const cap = Number(input?.maxMarketCapYi)
      const lim = Number(input?.resultLimit)
      if (!Number.isFinite(price) || price <= 0) return null
      if (!Number.isFinite(minCap) || minCap < 0) return null
      if (!Number.isFinite(cap) || cap <= 0) return null
      if (minCap > 0 && cap > 0 && minCap >= cap) return null
      if (!Number.isFinite(lim) || lim < 1 || lim > 500) return null
      return {
        maxPrice: Math.round(price),
        minMarketCapYi: Math.round(minCap),
        maxMarketCapYi: Math.round(cap),
        resultLimit: Math.round(lim)
      }
    },
    openAnalyzeConfig() {
      this.configDraft = {
        maxPrice: String(this.analyzeConfig.maxPrice),
        minMarketCapYi: String(this.analyzeConfig.minMarketCapYi),
        maxMarketCapYi: String(this.analyzeConfig.maxMarketCapYi),
        resultLimit: String(this.analyzeConfig.resultLimit),
        maxMidChipPct: this.maxMidChipPct
      }
      this.configDialogVisible = true
    },
    onConfigDigitsInput(field, value) {
      const digits = String(value || '').replace(/\D/g, '')
      this.configDraft[field] = digits
    },
    confirmAnalyzeConfig() {
      const normalized = this.normalizeAnalyzeConfig({
        maxPrice: this.configDraft.maxPrice,
        minMarketCapYi: this.configDraft.minMarketCapYi,
        maxMarketCapYi: this.configDraft.maxMarketCapYi,
        resultLimit: this.configDraft.resultLimit
      })
      if (!normalized) {
        const price = Number(this.configDraft.maxPrice)
        const minCap = Number(this.configDraft.minMarketCapYi)
        const cap = Number(this.configDraft.maxMarketCapYi)
        const lim = Number(this.configDraft.resultLimit)
        if (!Number.isFinite(price) || price <= 0) {
          this.$message.warning('请输入有效的价格上限')
          return
        }
        if (!Number.isFinite(minCap) || minCap < 0) {
          this.$message.warning('请输入有效的市值下限')
          return
        }
        if (!Number.isFinite(cap) || cap <= 0) {
          this.$message.warning('请输入有效的市值上限')
          return
        }
        if (minCap > 0 && cap > 0 && minCap >= cap) {
          this.$message.warning('市值下限须小于市值上限')
          return
        }
        if (!Number.isFinite(lim) || lim < 1 || lim > 500) {
          this.$message.warning('返回条数请在 1～500 之间')
          return
        }
        this.$message.warning('配置无效，请检查后重试')
        return
      }
      this.analyzeConfig = normalized
      this.saveAnalyzeConfigToStorage(normalized)
      if (!this.embedResults && this.pageTab === 'switch') {
        this.saveSwitchChipCap(String(this.configDraft.maxMidChipPct || '').trim())
      }
      this.configDialogVisible = false
    },
    async analyze(opts) {
      const silent = !!(opts && opts.silent)
      const switchMode = !this.embedResults && this.pageTab === 'switch'
      const dragons = this.embedResults ? (this.pickedEmbedDragons || []) : []
      const leaderCode = dragons.length ? dragons[0].code : (this.selectedLeader && this.selectedLeader.value)
      const leaderCodes = dragons.map((card) => card.code).filter(Boolean)
      const switchMains = switchMode
        ? [this.switchMain1, this.switchMain2].map((item) => String(item || '').trim()).filter(Boolean)
        : []
      if (!switchMode && !leaderCode) {
        if (!silent) this.$message.warning(this.embedResults && (this.embedDragonCards || []).length ? '请先点选龙头' : '请先选择龙头')
        return
      }
      if (this.analyzeLoading) {
        this._analyzeQueued = { silent }
        return
      }
      this.analyzeLoading = true
      try {
        const mainAttrs = switchMode
          ? switchMains
          : [
            this.attrForm.attrMain,
            this.attrForm.attrMain2,
            this.attrForm.attrMain3
          ]
            .map((x) => String(x || '').trim())
            .filter(Boolean)
        const res = await stockApi.analyzeFirstBoardPreselection(
          switchMode ? '' : leaderCode,
          switchMode ? [] : this.selectedConcepts,
          this.conceptSource,
          switchMode
            ? {
              maxPrice: this.analyzeConfig.maxPrice,
              minMarketCapYi: this.analyzeConfig.minMarketCapYi,
              maxMarketCapYi: this.analyzeConfig.maxMarketCapYi,
              resultLimit: this.analyzeConfig.resultLimit,
              customConcepts: [],
              refDate: this.switchBacktestDate || '',
              onlyChiNext: this.boardLock === 'chinext' ? true : this.boardLock === 'main' ? false : !!this.onlyChiNext,
              attrMain: switchMains[0] || '',
              attrMain2: switchMains[1] || '',
              attrMain3: '',
              attrSub1: '',
              attrSub2: '',
              attrSub3: '',
              leaderCodes: [],
              mode: 'switch',
              maxMidChipPct: this.parsedMaxMidChipPct(),
              filterMa250: this.filterMa250,
              filterSlope: this.filterSlope,
              filterDistToYearHigh: this.filterDistToYearHigh,
              slopeMinPct: this.slopeMinValue,
              distToYearHighMax: this.distToYearHighMaxValue
            }
            : {
              maxPrice: this.analyzeConfig.maxPrice,
              minMarketCapYi: this.analyzeConfig.minMarketCapYi,
              maxMarketCapYi: this.analyzeConfig.maxMarketCapYi,
              resultLimit: this.analyzeConfig.resultLimit,
              customConcepts: [
                ...this.customConcepts.map((item) => item.name),
                ...this.buZhangCustomConcepts
              ],
              refDate: this.refDate || '',
              onlyChiNext: this.boardLock === 'chinext' ? true : this.boardLock === 'main' ? false : !!this.onlyChiNext,
              attrMain: this.attrForm.attrMain || '',
              attrMain2: this.attrForm.attrMain2 || '',
              attrMain3: this.attrForm.attrMain3 || '',
              attrSub1: this.attrForm.attrSub1 || '',
              attrSub2: this.attrForm.attrSub2 || '',
              attrSub3: this.attrForm.attrSub3 || '',
              leaderCodes
            }
        )
        if (!res?.ok) {
          this.$message.error(res?.message || '分析失败')
          return
        }
        if (res.refDate && !this.embedResults) {
          if (switchMode) this.switchBacktestDate = res.refDate
          else this.refDate = res.refDate
        }
        let rows = Array.isArray(res.data) ? res.data : []
        if (mainAttrs.length) {
          rows = rows.filter((row) => {
            const hit = new Set(row.requiredMatchedConcepts || [])
            return mainAttrs.some((m) => hit.has(m))
          })
        }
        this.resultList = rows.map((row) => attachChipReviewScoreV1({ ...row }))
        this.pickSelectedRows = []
        if (this.$refs.resultTable) {
          this.$refs.resultTable.clearSelection()
        }
        const attrHint = mainAttrs.length
          ? `（${switchMode ? '主概念' : '主属性'}命中其一: ${mainAttrs.join(' / ')}）`
          : ''
        const dateHint = switchMode && res.refDate ? `（回测日 ${res.refDate}）` : ''
        if (!silent) this.$message.success(`分析完成，共返回 ${this.resultList.length} 条${dateHint}${attrHint}`)
      } catch (error) {
        const msg = String(error?.message || '')
        if (/timeout/i.test(msg)) {
          this.$message.error(switchMode ? '分析超时：可先填写主概念再试' : '分析超时：请先点选概念缩小范围后再试')
        } else {
          this.$message.error('分析失败')
        }
      } finally {
        this.analyzeLoading = false
        const queued = this._analyzeQueued
        this._analyzeQueued = null
        if (queued) this.analyze(queued)
      }
    },
    onSwitchDateChange() {
      if (this.pageTab !== 'switch' || !this.switchBacktestDate) return
      this.analyze()
    },
    onEmbedSyncClick() {
      if (this.embedResults) {
        this.$emit('sync-pools')
        return
      }
      this.syncToThs()
    },
    async syncToThs() {
      const switchMode = !this.embedResults && this.pageTab === 'switch'
      if (!this.showTableList.length || (!switchMode && !this.selectedLeader?.value)) {
        this.$message.warning('请先完成分析')
        return
      }
      const leaderName = switchMode
        ? '预选'
        : (this.selectedLeader.name || this.selectedLeader.label || '')
      const concepts = switchMode
        ? [this.switchMain1, this.switchMain2].map((item) => String(item || '').trim()).filter(Boolean)
        : this.selectedConcepts
      const codes = this.showTableList.map((row) => row.code).filter(Boolean)
      this.syncThsLoading = true
      try {
        const res = await stockApi.syncFirstBoardToThs(leaderName, codes, concepts, switchMode ? 'switch' : '')
        if (res?.authError) {
          this.$message.warning(res?.message || '同花顺 Cookie 已失效，请更新 THS_COOKIE')
          return
        }
        if (res?.thsEnabled === false) {
          this.$message.warning(res?.message || '未配置 THS_COOKIE')
          return
        }
        if (res?.partial) {
          this.$message.warning(res?.message || '部分账号同步失败')
          return
        }
        if (!res?.ok) {
          this.$message.error(res?.message || '同步失败')
          return
        }
        this.$message.success(res?.message || '同步成功')
      } catch (_error) {
        this.$message.error('同步失败')
      } finally {
        this.syncThsLoading = false
      }
    },
    onPickSelectionChange(rows) {
      this.pickSelectedRows = Array.isArray(rows) ? rows : []
    },
    lockedOnlyChiNext(code) {
      if (this.boardLock === 'chinext') return true
      if (this.boardLock === 'main') return false
      return !!(code && isChiNextBoard(code))
    },
    embedCode6(row) {
      return String((row && (row.code || row.ts_code)) || '')
        .trim()
        .split('.')[0]
        .replace(/\D/g, '')
        .padStart(6, '0')
        .slice(-6)
    },
    isEmbedPicked(row) {
      const code = this.embedCode6(row)
      if (!code || code === '000000') return false
      return (this.embedPickedCodes || []).some((item) => this.embedCode6({ code: item }) === code)
    },
    embedRowClassName({ row }) {
      if (!this.embedResults || !this.embedPickActive || !this.isEmbedPicked(row)) return ''
      return 'is-embed-picked'
    },
    embedPickPayload(row) {
      const code = this.embedCode6(row)
      if (!code || code === '000000') return null
      const concepts = []
      ;(row.requiredMatchedConcepts || []).forEach((name) => {
        const text = String(name || '').trim()
        if (text) concepts.push({ name: text, kind: 'required' })
      })
      ;(row.matchedConcepts || []).forEach((name) => {
        const text = String(name || '').trim()
        if (text) concepts.push({ name: text, kind: 'matched' })
      })
      ;(row.selectedMatchedConcepts || []).forEach((name) => {
        const text = String(name || '').trim()
        if (text) concepts.push({ name: text, kind: 'selected' })
      })
      return {
        code,
        name: row.name || '',
        currentPrice: row.currentPrice,
        midChip: row.midChip,
        marketValue: row.marketValue,
        matchScore: row.matchScore,
        concepts
      }
    },
    selectAllFiltered() {
      const payloads = []
      for (const row of this.showTableList || []) {
        const payload = this.embedPickPayload(row)
        if (payload) payloads.push(payload)
      }
      if (!payloads.length) {
        this.$message.warning('当前没有可全选的股票')
        return
      }
      this.$emit('preselect-select-all', payloads)
    },
    onEmbedTableRowClick(row, _column, event) {
      if (!this.embedResults || !this.embedPickActive || !row) return
      const el = event && event.target
      if (el && el.closest && el.closest('button, a, .el-button, .el-checkbox')) return
      const payload = this.embedPickPayload(row)
      if (!payload) return
      this.$emit('embed-pick', payload)
    },
    buildPreFirstBoardStock(row) {
      const code = String(row?.code || '').trim().split('.')[0]
      const concepts = [
        ...(Array.isArray(row?.selectedMatchedConcepts) ? row.selectedMatchedConcepts : []),
        ...(Array.isArray(row?.matchedConcepts) ? row.matchedConcepts : [])
      ]
      return {
        code,
        name: String(row?.name || '').trim(),
        boards: 1,
        themeName: concepts[0] || '',
        themeCode: '',
        limitUpTime: '',
        freeFloatMarketCap: Number.isFinite(Number(row?.marketValue)) ? Number(row.marketValue) : null
      }
    },
    async savePickAndReturn() {
      if (!this.isPickMode || !this.pickTradeDate) {
        this.$message.warning('缺少回填日期')
        return
      }
      if (!this.pickSelectedRows.length) {
        this.$message.warning('请先勾选个股')
        return
      }
      this.pickSaveLoading = true
      try {
        const pickedStocks = this.pickSelectedRows.map((row) => this.buildPreFirstBoardStock(row))
        await stockApi.savePreFirstBoardStocks({
          tradeDate: this.pickTradeDate,
          owner: Number(this.pickOwner),
          pickedStocks
        })
        const returnTo = String(this.$route.query.returnTo || '/review-notes')
        const query = {
          tradeDate: this.pickTradeDate,
          openCart: '1',
          cartOwner: this.pickOwner
        }
        if (this.$route.query.startDate) query.startDate = String(this.$route.query.startDate)
        if (this.$route.query.endDate) query.endDate = String(this.$route.query.endDate)
        this.$router.push({ path: returnTo, query })
      } catch (error) {
        this.$message.error(error?.response?.data?.message || error?.message || '保存失败')
      } finally {
        this.pickSaveLoading = false
      }
    }
  },
  created() {
    this.analyzeConfig = this.loadAnalyzeConfigFromStorage()
    this.maxMidChipPct = this.loadSwitchChipCap()
  },
  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
    document.addEventListener('click', this.closeAttrAssignMenu)
    document.addEventListener('scroll', this.closeAttrAssignMenu, true)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
    document.removeEventListener('click', this.closeAttrAssignMenu)
    document.removeEventListener('scroll', this.closeAttrAssignMenu, true)
  }
}
</script>

<style lang="scss" scoped>
.first-board-preselection {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;

  &.is-embed {
    height: auto;
    min-height: 0;
    .concepts-area {
      flex-shrink: 0;
    }
    .attr-actions {
      margin-left: auto;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    }
    .attr-actions .analyze-btn,
    .attr-actions .config-btn {
      margin-left: 0;
    }
    .results-area {
      height: auto;
      min-height: 0;
      flex-grow: 0;
    }
    .results-area-filter {
      flex-wrap: nowrap;
      align-items: flex-start;
    }
    .results-area-filter__controls {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px 12px;
      flex: 1;
      min-width: 0;
    }
      .results-area-filter .sync-ths-btn {
        margin-left: 12px;
        flex-shrink: 0;
        align-self: center;
        padding: 5px 10px;
        font-size: 12px;
      }
      .preselect-select-all-btn,
      .preselect-add-btn {
        margin-left: 8px;
        height: 24px;
        padding: 0 12px;
        border: 1px solid #1a73e8;
        border-radius: 6px;
        background: #1a73e8;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        flex-shrink: 0;
        align-self: center;
      }
      .preselect-select-all-btn {
        background: #fff;
        color: #1a73e8;
      }
      .preselect-add-btn.on {
        background: #fff;
        color: #1a73e8;
      }
  }

  .search-area,
  .concepts-area,
  .results-area {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    box-sizing: border-box;
  }

  .page-tabs {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }

  .page-tab {
    border: 1px solid #dcdfe6;
    background: #fff;
    color: #606266;
    border-radius: 4px;
    padding: 6px 14px;
    cursor: pointer;
    line-height: 20px;

    &.is-active {
      color: #fff;
      background: #409eff;
      border-color: #409eff;
    }
  }

  .switch-search {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px 16px;

    .switch-search__row {
      display: inline-flex;
      align-items: center;
      gap: 8px;
    }
  }

  .search-area {
    padding: 14px 16px;
    flex-shrink: 0;

    .search-row + .search-row {
      margin-top: 12px;
    }

    .search-row {
      .search-area-label {
        display: inline-block;
        min-width: 3.5em;
        margin-right: 8px;
        color: #606266;
        text-align: right;
        flex-shrink: 0;
        white-space: nowrap;
      }

      .search-area-select {
        width: 200px;
      }
    }

    .search-row--dates {
      .search-area-label {
        min-width: 4em;
      }

      /* Element 默认 .el-date-editor.el-input { width: 220px }，需更高优先级覆盖 */
      ::v-deep .el-date-editor.el-input.search-area-date {
        width: 280px;
      }
    }

    .analyze-btn {
      margin-left: 10px;
    }

    .search-col-actions .analyze-btn {
      margin-left: 0;
    }

    .config-btn {
      margin-left: 8px;
    }

    .chinext-check {
      margin-left: 10px;
      white-space: nowrap;
      color: #35598c;
      font-size: 13px;
    }

    .leader-meta {
      margin-left: 10px;
      display: inline-flex;
      align-items: center;
      gap: 10px;
      vertical-align: middle;
      flex-wrap: wrap;
    }

    .leader-price,
    .leader-ffmc {
      font-size: 12px;
      color: #1a73e8;
      font-weight: 600;
      white-space: nowrap;
    }

    .search-area__row--ffmc {
      margin-top: 4px;
      .leader-meta {
        margin-left: 0;
      }
    }
  }

  /* Web 桌面紧凑：仅 CSS @media，H5（≤768）与平板不受影响 */
  @media screen and (min-width: 1025px) {
    gap: 8px;

    .search-area:not(.search-area--mobile) {
      padding: 12px 14px;

      .search-row + .search-row {
        margin-top: 10px;
      }

      .search-row.el-row {
        gap: 12px;
      }

      ::v-deep {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
          font-size: 13px;
        }

        .el-input__icon {
          line-height: 32px;
        }

        .el-button {
          height: 32px;
          padding: 0 14px;
          font-size: 13px;
        }
      }
    }

    .concepts-area {
      padding: 10px 14px;

      .concepts-title {
        margin: 0;
        font-size: 13px;

        .add-concept {
          margin-left: 10px;

          .concepts-title-input {
            width: 220px;
            margin-right: 8px;
          }

          ::v-deep {
            .el-input__inner {
              height: 32px;
              line-height: 32px;
              font-size: 13px;
            }

            .el-input__icon {
              line-height: 32px;
            }

            .el-button {
              height: 32px;
              padding: 0 14px;
              font-size: 13px;
            }
          }
        }
      }

      .attr-slots {
        gap: 10px 16px;
        margin-top: 10px;

        .attr-slot__label {
          font-size: 13px;
        }

        .attr-slot__select {
          width: 180px;
        }

        ::v-deep .el-input__inner {
          height: 34px;
          line-height: 34px;
          font-size: 13px;
        }
      }

      .concepts-list {
        gap: 12px 14px;
        row-gap: 12px;
        min-height: 0;
        max-height: 220px;
        margin-top: 14px;
        padding: 4px 2px 10px;

        .concept-item {
          line-height: 1;
        }

        ::v-deep {
          .el-tag.concept-tag {
            height: 30px;
            line-height: 28px;
            padding: 0 12px;
            font-size: 13px;
          }

          .concept-item-badge .el-badge__content.is-fixed {
            top: -5px;
            right: -8px;
            height: 14px;
            line-height: 14px;
            padding: 0 3px;
            font-size: 10px;
            transform: scale(0.85);
          }

          .concept-item-badge--count .el-badge__content.is-fixed {
            top: -6px;
            right: -8px;
            height: 16px;
            line-height: 16px;
            padding: 0 4px;
            font-size: 11px;
            font-weight: 700;
            background: #409eff;
            border: none;
            transform: none;
          }
        }
      }

      .concept-tag:hover {
        transform: none;
        box-shadow: none;
      }
    }

    .results-area {
      padding: 10px 12px 12px;

      ::v-deep {
        .el-table {
          font-size: 13px;

          th {
            background: #f5f7fa !important;
            color: #606266;
            font-weight: 600;
          }

          th,
          td {
            padding: 6px 0 !important;
          }

          .cell {
            line-height: 1.35;
            padding-left: 8px !important;
            padding-right: 8px !important;
          }

          .el-tag {
            height: 22px;
            line-height: 20px;
            padding: 0 6px;
            font-size: 12px;
          }

          .el-table__body-wrapper {
            height: calc(100% - 40px);
          }
        }
      }
    }
  }

  /* Web 端：龙头 / 概念 / 开始分析 横向紧凑排列，不占满整行栅格 */
  @media screen and (min-width: 1024px) {
    .search-area {
      .search-row.el-row {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 16px;
      }

      .search-row.el-row > .el-col {
        display: inline-flex !important;
        align-items: center;
        flex: 0 0 auto !important;
        width: auto !important;
        max-width: none !important;
      }

      .search-area-label {
        margin-right: 8px;
      }

      .analyze-btn {
        margin-left: 0;
      }

      .search-col-actions {
        display: inline-flex;
        align-items: center;
        gap: 8px;
      }

      .search-col-actions .config-btn {
        margin-left: 0;
      }

      .search-row--buzhang.el-row {
        flex-wrap: wrap;
      }
    }
  }

  /* H5：龙头行 = 标签 + 龙头下拉 + 配置；概念行 = 标签 + 来源下拉 + 开始分析 */
  .search-area.search-area--mobile {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 15px;

    .search-area-label {
      flex-shrink: 0;
    }

    .search-area__row {
      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      gap: 8px;
      min-width: 0;
    }

    .search-area__row--leader {
      flex-wrap: nowrap;
      gap: 4px;
      justify-content: flex-start;

      /* 与原先 H5 龙头行一致：不占满整行，最大 200px */
      ::v-deep .el-select.search-area-select {
        flex: 0 1 auto;
        width: calc(100% - 110px);
        max-width: 200px;
      }

      .config-btn {
        flex-shrink: 0;
        margin-left: 0;
      }
    }

    .search-row--buzhang {
      margin-top: 10px;
    }

    .search-area__row--buzhang {
      flex-wrap: nowrap;
      gap: 4px;
      justify-content: flex-start;

      ::v-deep .el-select.search-area-select {
        flex: 0 1 auto;
        width: calc(100% - 70px);
        max-width: 200px;
      }
    }

    .search-area__row--concept {
      flex-wrap: nowrap;
      gap: 4px;
      justify-content: flex-start;

      /* 概念下拉同样 capped 200px，为「开始分析」预留右侧宽度 */
      ::v-deep .el-select.search-area-select {
        flex: 0 1 auto;
        width: calc(100% - 150px);
        max-width: 200px;
      }

      .analyze-btn {
        flex-shrink: 0;
        margin-left: 0;
      }
    }

    &.switch-search .switch-search__row {
      flex-wrap: wrap;
    }
  }

  .concepts-area {
    padding: 12px 16px;
    flex-shrink: 0;

    &--empty {
      .concepts-title {
        margin-bottom: 0;
      }
    }

    .concepts-title {
      font-weight: 600;
      color: #303133;
      margin: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;

      &__text {
        flex-shrink: 0;
      }

      .add-concept {
        display: flex;
        align-items: center;
        margin-left: 0;

        .concepts-title-input {
          width: 200px;
          margin-right: 8px;
        }
      }
    }

    .attr-slots {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 12px 18px;
      margin-top: 12px;

      .attr-slot {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        min-width: 0;
      }

      .attr-slot__label {
        flex-shrink: 0;
        font-size: 14px;
        font-weight: 600;
        color: #606266;
        white-space: nowrap;
      }

      .attr-slot__select {
        width: 200px;
      }

      ::v-deep .el-input__inner {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
      }

      &--mobile {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;

        .attr-slot {
          width: 100%;
        }

        .attr-slot__select {
          flex: 1;
          width: auto;
          min-width: 0;
        }
      }
    }

    .concepts-list {
      display: flex;
      flex-wrap: wrap;
      gap: 14px 16px;
      min-height: 0;
      max-height: 280px;
      overflow-y: auto;
      margin-top: 16px;
      padding: 6px 4px 12px;
    }

    .concept-item-badge--count ::v-deep .el-badge__content.is-fixed {
      top: -6px;
      right: -8px;
      height: 16px;
      line-height: 16px;
      padding: 0 4px;
      font-size: 11px;
      font-weight: 700;
      background: #409eff;
      border: none;
      transform: none;
    }

    .concept-tag {
      cursor: pointer;
      transition: all 0.2s;
    }

    .concept-tag--attr {
      user-select: none;
      -webkit-user-select: none;
      -webkit-touch-callout: none;
      touch-action: manipulation;
    }

    .concepts-list ::v-deep .el-tag.concept-tag {
      height: 32px;
      line-height: 30px;
      padding: 0 12px;
      font-size: 14px;
    }

    .concept-tag:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
    }

    .attr-assign-menu {
      position: fixed;
      z-index: 4000;
      min-width: 180px;
      max-width: 260px;
      padding: 6px 0;
      background: #fff;
      border: 1px solid #e4e7ed;
      border-radius: 6px;
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
    }

    .attr-assign-menu__title {
      padding: 6px 12px 8px;
      font-size: 12px;
      color: #909399;
      border-bottom: 1px solid #f0f2f5;
      word-break: break-all;
    }

    .attr-assign-menu__item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      width: 100%;
      padding: 9px 12px;
      border: 0;
      background: transparent;
      text-align: left;
      font-size: 13px;
      color: #303133;
      cursor: pointer;

      &:hover {
        background: #f5f7fa;
        color: #409eff;
      }
    }

    .attr-assign-menu__cur {
      max-width: 110px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
      color: #909399;
    }

    @media screen and (min-width: 769px) and (max-width: 1024px) {
      .concepts-list ::v-deep .concept-item-badge .el-badge__content.is-fixed {
        top: 5px;
        right: 15px;
      }
    }
  }

  .results-area {
    padding: 12px 16px 16px;
    flex-grow: 1;
    min-height: 0;
    height: 0;
    display: flex;
    flex-direction: column;

    .results-toolbar {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 10px;
      flex-shrink: 0;

      .sync-ths-btn {
        padding: 5px 10px;
        font-size: 12px;
      }

      &__hint {
        color: #909399;
        font-size: 12px;
      }
    }

    .results-area-filter {
      margin-bottom: 10px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 8px 12px;
      flex-shrink: 0;

      .preselect-select-all-btn {
        margin-left: auto;
      }
      .preselect-add-btn,
      .preselect-select-all-btn {
        height: 24px;
        padding: 0 12px;
        border: 1px solid #1a73e8;
        border-radius: 6px;
        background: #1a73e8;
        color: #fff;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        flex-shrink: 0;
      }
      .preselect-select-all-btn {
        background: #fff;
        color: #1a73e8;
      }
      .preselect-add-btn {
        margin-left: 8px;
      }
      .preselect-add-btn.on {
        background: #fff;
        color: #1a73e8;
      }

      .results-area-filter__controls {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 12px;
        min-width: 0;
      }

      .filter-rel-vol-label {
        margin-left: 4px;
        color: #606266;
        font-size: 14px;
        flex-shrink: 0;
      }
      .chip-tier-filter-row {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 4px 8px;
        max-width: 100%;
      }
      .chip-tier-buttons {
        display: inline-flex;
        flex-wrap: wrap;
        gap: 4px;
      }
      .chip-tier-btn {
        border: 1px solid #dcdfe6;
        background: #fff;
        color: #606266;
        font-size: 12px;
        line-height: 1.2;
        padding: 4px 8px;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.15s ease;

        &:hover {
          border-color: #c0c4cc;
          color: #409eff;
        }
        &.is-active {
          border-color: #409eff;
          background: #ecf5ff;
          color: #409eff;
        }
      }
      .filter-rel-vol-group {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: center;
      }
    }

    .pick-mode-banner {
      margin-bottom: 10px;
      padding: 8px 12px;
      border-radius: 4px;
      background: #ecf5ff;
      color: #409eff;
      font-size: 13px;
      font-weight: 600;
      flex-shrink: 0;
    }

    .pick-mode-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 12px;
      flex-shrink: 0;

      &__hint {
        color: #909399;
        font-size: 13px;
      }
    }

    .concept-details {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 4px;
    }

    ::v-deep {
      .el-table {
        flex: 1 1 auto;
        width: 100%;

        tr.is-embed-picked > td {
          background: #e8f1ff !important;
        }

        .el-table__header-wrapper,
        .el-table__body-wrapper {
          width: 100%;
        }

        .el-table__body-wrapper {
          height: calc(100% - 48px);
          overflow-y: auto;
        }

        th {
          background: #f5f7fa;
        }
      }
      .highlight-name {
        background-color: #fffacd;
        color: #d48806;
        padding: 2px;
        border-radius: 3px;
        font-weight: 500;
      }
      .chip-review-cell {
        display: inline-flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 4px 6px;
        line-height: 1.25;
        max-width: 100%;
      }
      .chip-review-cell__score {
        font-variant-numeric: tabular-nums;
        font-weight: 600;
        color: #303133;
      }
      .chip-review-cell__tier {
        font-size: 12px;
        color: #606266;
      }
      .chip-review-cell--s .chip-review-cell__score {
        color: #5c4b2a;
      }
      .chip-review-cell--a .chip-review-cell__score {
        color: #3a4a5c;
      }
      .chip-review-cell--b .chip-review-cell__score,
      .chip-review-cell--b .chip-review-cell__tier {
        color: #606266;
        font-weight: 500;
      }
      .chip-review-cell--splus {
        padding: 3px 8px;
        border-radius: 6px;
        border: 1px solid rgba(196, 163, 90, 0.55);
        background: linear-gradient(180deg, #fbf7ef 0%, #f3ead8 100%);
        box-shadow: 0 1px 2px rgba(138, 106, 47, 0.08);
      }
      .chip-review-cell--splus .chip-review-cell__mark {
        color: #b08d3a;
        font-size: 12px;
        line-height: 1;
      }
      .chip-review-cell--splus .chip-review-cell__score {
        font-weight: 800;
        color: #6e5420;
        letter-spacing: 0.02em;
      }
      .chip-review-cell--splus .chip-review-cell__badge {
        display: inline-block;
        font-size: 11px;
        font-weight: 700;
        line-height: 1;
        padding: 2px 6px;
        border-radius: 999px;
        color: #6e5420;
        background: rgba(196, 163, 90, 0.22);
        border: 1px solid rgba(176, 141, 58, 0.35);
      }
      .chip-review-cell--splus .chip-review-cell__hint {
        flex-basis: 100%;
        font-size: 10px;
        color: #9a7d45;
        letter-spacing: 0.04em;
      }
    }
  }

  @media screen and (max-width: 1023px) {
    gap: 8px;

    .search-area {
      padding: 12px;
      .search-row {
        .search-area-label {
          display: inline-block;
          width: auto;
          margin-bottom: 5px;
          text-align: left;
        }
        .search-area-select {
          width: calc(100% - 60px);
          max-width: 200px;
        }
      }
    }
    .concepts-area,
    .results-area {
      padding: 12px;
    }
    .concepts-area {
      .concepts-title {
        margin: 0;

        .add-concept {
          margin-left: 0;

          .concepts-title-input {
            width: 180px;
          }
        }
      }

      .concepts-list {
        max-height: 72px;
        gap: 6px;
      }
    }
    .sm-mt {
      margin-top: 12px;
    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1024px) {
    .md-mt {
      margin-top: 12px;
    }
  }

  @media screen and (max-width: 768px) {
    .results-area {
      ::v-deep td.first-board-concepts-col .cell {
        overflow: hidden !important;
        vertical-align: middle;
        white-space: normal !important;
      }

      .concept-details--h5-strip {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        gap: 4px;
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
          display: none;
          width: 0;
          height: 0;
        }

        ::v-deep .el-tag {
          flex-shrink: 0;
        }
      }
    }
    ::v-deep {
      .concept-item-badge .el-badge__content.is-fixed {
        top: -5px !important;
        right: -8px !important;
        height: 16px;
        line-height: 16px;
        padding: 0 5px;
        font-size: 12px;
        transform: scale(0.85);
      }
    }
  }

}
</style>

<style lang="scss">
/* el-dialog append-to-body 后不在 scoped 根下，用 custom-class 定位 */
.first-board-config-dialog .config-dialog-input {
  width: 160px;
  vertical-align: middle;
}
.first-board-config-dialog .config-dialog-unit {
  margin-left: 8px;
  color: #606266;
  font-size: 14px;
}
@media screen and (max-width: 480px) {
  .first-board-config-dialog {
    width: 92% !important;
  }
}
.tip {
  margin: 0 0 12px;
  color: #606266;
  font-size: 13px;
  line-height: 1.5;
}
.band-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.band-idx {
  width: 56px;
  color: #303133;
  font-size: 13px;
}
.band-sep {
  color: #909399;
}
.unit {
  color: #909399;
  font-size: 12px;
}
</style>
